module.exports = __webpack_public_path__ + "static/media/60.b5c822cd.png";